import React from 'react';
import './main.less';

import { Link } from 'react-router';

import moment from 'moment';
import map from 'lodash/map';
import findKey from 'lodash/findKey';

import {
	locale as bannerCustomContentLocale,
	enum as bannerCustomContentIds
} from '../../../../../../../enums/banner-custom-content-ids';
import {
	enum as bannerTypes
} from '../../../../../../../enums/banner-types';

function renderContent({ value }, { intl }) {
	return (
		<div>
			{map(value, ({ list, interval }, lang) => !!list.length && (
				<div className='banners-lang-list' key={lang}>
					<div className={`flag-icon flag-icon-${lang}`} />
					<div className='banners-lang-list-data'>
						{list.map(({ type, image, link, contentId }, i) => type !== bannerTypes.custom ? (
							<div className='banners-lang-list-data-block' key={i}>
								<div>image: <a href={image} target='_blank'>{image}</a></div>
								<div>link: <a href={link} target='_blank'>{link}</a></div>
							</div>
						) : (
							<div className='banners-lang-list-data-block' key={i}>
								Custom content: {
									bannerCustomContentLocale[intl.language][findKey(bannerCustomContentIds, id => id === contentId)]
								}
							</div>
						))}
						{interval && (
							<div className='banners-lang-list-data-block'>
								{intl('interval')}: {interval} {intl('ms')}
							</div>
						)}
					</div>
				</div>
			))}
		</div>
	);
}

function renderActions(_, { row }) {
	return (
		<div>
			<Link
				className='banners-edit-icon'
				to={`/banners/contents/${row.id}/editor`}
			/>
		</div>
	);
}

export default [
	[
		{
			index: 'id',
			header: {
				title: 'ID'
			},
			column: {}
		},
		{
			index: 'title',
			header: {
				title: 'title'
			},
			column: {
				className: 'banners-content-table-title'
			}
		},
		{
			index: 'content',
			header: {
				title: 'content'
			},
			column: {
				render: renderContent
			}
		},
		{
			index: 'created_at',
			header: {
				title: 'created at'
			},
			column: {
				format: v => moment(v).format('DD.MM.YYYY HH:mm')
			}
		},
		{
			index: 'actions',
			header: {
				title: 'actions'
			},
			column: {
				render: renderActions
			}
		}
	]
];


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/banners/content/list/table-initial-data.js